import { mapActions, mapMutations } from 'vuex';

import iframeMixin from '@/mixins/iframe';

import GoalMetricIcon from '@svgIcons/dashboard/goal_metric.svg';
import RingLoader from '@components/Common/RingLoader';

import * as C from '../../../options/styles';
import { Wrapper } from './styles';

import { isValueExist } from '@/utils/utils';
import { IFRAME_EVENT_MESSAGE } from '@/utils/consts';
import { FIELD_PANEL_KEY } from '../../consts';

import TargetItem from './TargetItem';

export const TargetSetting = {
    name: 'TargetSetting',
    mixins: [iframeMixin],
    props: {
        currentList: {
            type: Array,
            default() {
                return [];
            },
        },
        secondPanelLoading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        selectedSource: {
            type: Array,
            default() {
                return [];
            },
        },
        currentBreakdownIds: {
            type: Array,
            default() {
                return [];
            },
        },
        isAnalytic: {
            type: Boolean,
            default: false,
        },
        teamspaceId: Number,
        currentViewId: [Number, String],
        widgetType: String,
        graphOptions: {
            type: Object,
            default() {
                return {};
            },
        },
        canEditCustomMetric: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            iframeListeners_: [
                {
                    eventType:
                        IFRAME_EVENT_MESSAGE.UPDATE_GOAL_WIDGET_RANGE_SETTING,
                    listener: (event) => {
                        const { childWidgetData = {} } = event.data;
                        this.updateChildWidgetGoal(childWidgetData);

                        this.setGoalRangeSettingData({});

                        this.postIframeMessage({
                            type: IFRAME_EVENT_MESSAGE.TOGGLE_GOAL_WIDGET_RANGE_SETTING,
                            origin: 'VUE',
                            data: { childWidgetData: {} },
                        });
                    },
                },
            ],
        };
    },
    methods: {
        ...mapMutations('newDashboard', ['setGoalRangeSettingData']),
        ...mapActions('iframe', ['postIframeMessage']),
        updateChildWidgetGoal(column) {
            const key = column.key;
            const { currentList } = this;
            const cloned = [...currentList];
            const index = cloned.findIndex((m) => m.key === key);
            const updated = R.compose(
                R.assocPath([index, 'goalInfo'], column.goalInfo),
                R.assocPath([index, 'goalRange'], column.goalRange)
            )(cloned);
            this.$emit('update', updated);
        },
    },
    render() {
        const {
            currentList,
            secondPanelLoading,
            selectedSource,
            currentBreakdownIds,
            isAnalytic,
            teamspaceId,
            currentViewId,
            widgetType,
            graphOptions,
            canEditCustomMetric,
            disabled,
        } = this;

        return (
            <C.ComponentWrapper>
                <C.ListWrapper
                    class="option-wrapper"
                    onclick={(e) => e.stopPropagation()}
                >
                    <C.TitleLabel
                        class="option-title"
                        hideBorder={!isValueExist(currentList)}
                    >
                        <C.IconWrapper class="option-title-text">
                            <GoalMetricIcon class="metric-icon" />
                            {this.$t('NEW_DASHBOARD.goal_metrics')}
                        </C.IconWrapper>
                        {secondPanelLoading && <RingLoader size={16} />}
                    </C.TitleLabel>
                    <C.ItemWrapper>
                        {isValueExist(currentList) ? (
                            <Wrapper className={'goal-metrics-wrapper'}>
                                {currentList.map((item, index) => (
                                    <TargetItem
                                        key={`${item.key}-${index}`}
                                        panelKey={FIELD_PANEL_KEY.GOAL_TARGET_METRIC(
                                            item.key
                                        )}
                                        itemData={item}
                                        index={index}
                                        updateChildWidgetGoal={
                                            this.updateChildWidgetGoal
                                        }
                                        selectedSource={selectedSource}
                                        currentBreakdownIds={
                                            currentBreakdownIds
                                        }
                                        isAnalytic={isAnalytic}
                                        teamspaceId={teamspaceId}
                                        currentViewId={currentViewId}
                                        widgetType={widgetType}
                                        graphOptions={graphOptions}
                                        canEditCustomMetric={
                                            canEditCustomMetric
                                        }
                                        disabled={disabled}
                                    />
                                ))}
                            </Wrapper>
                        ) : (
                            <C.NoListSpan>
                                {this.$t('FIELD_PANEL.metric.empty_metric')}
                            </C.NoListSpan>
                        )}
                    </C.ItemWrapper>
                </C.ListWrapper>
            </C.ComponentWrapper>
        );
    },
};
